module.exports = __webpack_public_path__ + "img/voltar.40c09c8a.svg";